import React from 'react'

import { COLORS } from 'utils'

import { IconStyles } from '../types'
import { BlockCustom } from './styles'

interface BlockProps extends IconStyles {
  onClick?: any
}

export const BlockIcon: React.FC<BlockProps> = ({
  disabled,
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}) => {
  return (
    <BlockCustom
      disabled={disabled}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={disabled ? 'default' : cursor}
      onClick={disabled ? () => null : onClick}
      colorIcon={disabled ? COLORS.gray : colorIcon}
    />
  )
}
